import { ProductPageTemplate } from "@/components/products/ProductPageTemplate";
import {
  Search, FileCheck, Copy, Database, FileText, Upload,
  RefreshCw, Mail, Shield,
} from "lucide-react";
import iconAdresstwatt from "@/assets/icon-adresstwatt.jpg";
import { AdresstwattPricing } from "@/components/products/AdresstwattPricing";
import type { FeatureGroup, UseCase, Benefit, Step } from "@/components/products/types";

const featureGroups: FeatureGroup[] = [
  {
    titleKey: "productPages.adresstwatt.featureGroups.analyze",
    illustrationKey: "adresstwatt-analyze",
    features: [
      {
        titleKey: "productPages.adresstwatt.features.items.analyze.title",
        descriptionKey: "productPages.adresstwatt.features.items.analyze.description",
        icon: Search,
      },
      {
        titleKey: "productPages.adresstwatt.features.items.duplicates.title",
        descriptionKey: "productPages.adresstwatt.features.items.duplicates.description",
        icon: Copy,
      },
      {
        titleKey: "productPages.adresstwatt.features.items.report.title",
        descriptionKey: "productPages.adresstwatt.features.items.report.description",
        icon: FileText,
      },
    ],
  },
  {
    titleKey: "productPages.adresstwatt.featureGroups.correctAndEnrich",
    illustrationKey: "adresstwatt-correct",
    features: [
      {
        titleKey: "productPages.adresstwatt.features.items.correct.title",
        descriptionKey: "productPages.adresstwatt.features.items.correct.description",
        icon: FileCheck,
      },
      {
        titleKey: "productPages.adresstwatt.features.items.enrich.title",
        descriptionKey: "productPages.adresstwatt.features.items.enrich.description",
        icon: Database,
      },
      {
        titleKey: "productPages.adresstwatt.features.items.flexible.title",
        descriptionKey: "productPages.adresstwatt.features.items.flexible.description",
        icon: Upload,
      },
    ],
  },
];

const useCases: UseCase[] = [
  {
    titleKey: "productPages.adresstwatt.useCases.items.registerCare.title",
    descriptionKey: "productPages.adresstwatt.useCases.items.registerCare.description",
    icon: RefreshCw,
  },
  {
    titleKey: "productPages.adresstwatt.useCases.items.campaigns.title",
    descriptionKey: "productPages.adresstwatt.useCases.items.campaigns.description",
    icon: Mail,
  },
  {
    titleKey: "productPages.adresstwatt.useCases.items.gdpr.title",
    descriptionKey: "productPages.adresstwatt.useCases.items.gdpr.description",
    icon: Shield,
  },
];

const benefits: Benefit[] = [
  {
    titleKey: "productPages.adresstwatt.benefits.items.quality.title",
    descriptionKey: "productPages.adresstwatt.benefits.items.quality.description",
  },
  {
    titleKey: "productPages.adresstwatt.benefits.items.savings.title",
    descriptionKey: "productPages.adresstwatt.benefits.items.savings.description",
  },
  {
    titleKey: "productPages.adresstwatt.benefits.items.compliance.title",
    descriptionKey: "productPages.adresstwatt.benefits.items.compliance.description",
  },
];

const steps: Step[] = [
  {
    titleKey: "productPages.adresstwatt.howItWorks.steps.first.title",
    descriptionKey: "productPages.adresstwatt.howItWorks.steps.first.description",
  },
  {
    titleKey: "productPages.adresstwatt.howItWorks.steps.second.title",
    descriptionKey: "productPages.adresstwatt.howItWorks.steps.second.description",
  },
  {
    titleKey: "productPages.adresstwatt.howItWorks.steps.third.title",
    descriptionKey: "productPages.adresstwatt.howItWorks.steps.third.description",
  },
];

const AdresstwattPage = () => {
  return (
    <ProductPageTemplate
      productKey="adresstwatt"
      icon={iconAdresstwatt}
      featureGroups={featureGroups}
      useCases={useCases}
      benefits={benefits}
      steps={steps}
      accentClass="bg-turquoise/10"
      additionalSections={[
        {
          position: "before-benefits",
          component: <AdresstwattPricing />,
        },
      ]}
    />
  );
};

export default AdresstwattPage;
